import React from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button, OptionsTestPreview, WordboxTestPreview,
  TranslationTestPreview, Tag } from '../components'
import { setCurrentLesson } from '../../common/lessons/actions'
import { exerciseTypes } from '../../common/config'


const LessonItemBox = ({ lesson, intl, saveLesson, savedLessons,
  ownLessons, isTestForm, setCurrentLesson }) => (
  <div
    className="lesson-box-preview"
    onClick={() => setCurrentLesson(lesson)}
  >
    <h3>{lesson.name}</h3>
    {/*
    <div className="tags-list">
      {lesson.tags.map(t => <Tag key={t.id} tag={t} />)}
    </div>
    */}
    {
      lesson.type === exerciseTypes.OPTIONS &&
      <OptionsTestPreview
        testOutlook
        lesson={lesson}
        isDetailPage
        intl={intl}
      />
    }
    {
      lesson.type === exerciseTypes.WORDBOX &&
      <WordboxTestPreview
        testOutlook
        lesson={lesson}
        isDetailPage
        intl={intl}
      />
    }
    {
      lesson.type === exerciseTypes.TRANSLATION &&
      <TranslationTestPreview
        testOutlook
        lesson={lesson}
        isDetailPage
        intl={intl}
      />
    }
    <div className="buttons-row">
      <Button
        positive
        className="disable-spacing-left spacing-top"
        onClick={(e) => { 
          e.stopPropagation()
          saveLesson(lesson.id) 
        }}
        disabled={savedLessons.includes(lesson.id) ||
          ownLessons.some(l => l.id === lesson.id)}
      >
        {intl.formatMessage(isTestForm ? messages.addToTest : messages.save)}
      </Button>
      <Button>
        {intl.formatMessage(messages.show)}
      </Button>
    </div>
  </div>
)

const enhance = compose(
  injectIntl,
  connect(() => ({ }), { setCurrentLesson }),
)

const messages = defineMessages({
  save: {
    id: 'lessonItemBox.save',
    defaultMessage: 'Uložiť',
  },
  show: {
    id: 'lessonItemBox.show',
    defaultMessage: 'Zobraziť cvičenie',
  },
  addToTest: {
    id: 'lessonItemBox.addToTest',
    defaultMessage: 'Pridať do testu',
  },
  remove: {
    id: 'lessonItemBox.remove',
    defaultMessage: 'Odobrať z testu',
  },
})


export default enhance(LessonItemBox)



// WEBPACK FOOTER //
// ./src/browser/components/LessonItemBox.js